export const offerStateEnum = {
  matched: 'MATCHED',
  expired: 'EXPIRED',
  new: 'NEW',
  none: 'NONE',
};

export const MatchingStateEnum = {
  none: 'NONE',
  primarySso: 'PRIMARY_SSO',
  primaryNonSso: 'PRIMARY_NON_SSO',
  coapplicant: 'COAPPLICANT',
};

export class CustomerOffer {
  constructor(
    offerTypeCode,
    annualPercentRate,
    financedAmount,
    loanTermNumber,
    monthlyPaymentAmount,
    isExpired,
    promotionalCode,
    offerState,
    cachedTaxId,
    lastFourTaxId
  ) {
    this.offerTypeCode = offerTypeCode;
    this.annualPercentRate = annualPercentRate;
    this.financedAmount = financedAmount;
    this.loanTermNumber = loanTermNumber;
    this.monthlyPaymentAmount = monthlyPaymentAmount;
    this.isExpired = isExpired;
    this.promotionalCode = promotionalCode;
    this.offerState = offerState;
    this.cachedTaxId = cachedTaxId;
    this.lastFourTaxId = lastFourTaxId;
  }
}
